export const NOT_ASSIGNED_USER = {
  initials: 'NA',
  Name: 'Not Assigned'
} as const;
